import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact">
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p className="subtitle">We're here to help. Get in touch with our team.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid-layout">
            <div className="contact-info-section">
              <h2>Get In Touch</h2>
              <p>
                Have questions about our platform? Ready to apply? We're here to help travel agents
                succeed.
              </p>

              <div className="contact-method">
                <h3>✉️ Email</h3>
                <div className="email-list">
                  <div className="email-item">
                    <strong>General Inquiries:</strong>
                    <a href="mailto:hello@cruisespotterconnect.com">hello@cruisespotterconnect.com</a>
                  </div>
                  <div className="email-item">
                    <strong>Agent Support:</strong>
                    <a href="mailto:agents@cruisespotterconnect.com">agents@cruisespotterconnect.com</a>
                  </div>
                  <div className="email-item">
                    <strong>Billing Questions:</strong>
                    <a href="mailto:billing@cruisespotterconnect.com">billing@cruisespotterconnect.com</a>
                  </div>
                  <div className="email-item">
                    <strong>Technical Support:</strong>
                    <a href="mailto:support@cruisespotterconnect.com">support@cruisespotterconnect.com</a>
                  </div>
                </div>
              </div>

              <div className="contact-method">
                <h3>⏰ Business Hours</h3>
                <p className="contact-detail">Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                <p className="contact-note">
                  We typically respond to emails within 24 hours during business days.
                </p>
              </div>
            </div>

            <div className="contact-form-section">
              <h2>Ready to Apply?</h2>
              <p>
                Click the button below to send us an email with your application or inquiry.
                We'll respond within 24 hours during business days.
              </p>
              <a
                href="mailto:hello@cruisespotterconnect.com?subject=Travel Agent Application"
                className="btn btn-primary btn-large"
                style={{ display: 'inline-block', marginTop: '20px' }}
              >
                Send Email
              </a>
              <p className="form-note" style={{ marginTop: '20px' }}>
                Please include your name, contact information, and any questions you have about
                joining our network. You can also email any of the specific addresses listed on the left.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section gray">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <p className="faq-intro">
            Looking for quick answers? Check out our <a href="/faq">FAQ page</a> for common questions
            about pricing, billing, how the platform works, and more.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;
